import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ShippingService } from '../../services/api-services/shipping.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-req-add-reason',
  templateUrl: './req-add-reason.component.html',
  styleUrls: ['./req-add-reason.component.scss']
})
export class ReqAddReasonComponent implements OnInit {
  reasonValue: string = '';
  isLoading = false;
  constructor(
    public dialogRef: MatDialogRef<ReqAddReasonComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private shippingService: ShippingService,
    private toastr: ToastrService,
  ) { }

  ngOnInit(): void {
    this.reasonValue = this.data?.item?.reason?.value || this.data?.item?.reasonText || '';
  }

  submitForm(): void {
    this.isLoading = true;
    const payload = {
      "request_type": this.data?.item?.request_type || '',
      "refill_request_id": this.data?.item?.refill_request_id || '',
      "reason_id": this.data?.item?.reason?.key || 0,
      "type": this.data?.item?.type || '',
    }
    this.shippingService.assign_reason(payload).subscribe({
      next: (res) => {
        if (res?.body?.success) {
          this.isLoading = false;
          this.toastr.success(res?.body?.message);
          this.dialogRef.close(res?.body?.success);
        } else {
          this.toastr.error(res?.body?.message);
          this.isLoading = false;
        }
      },
      error: (err) => {
        console.error("err::", err);
        this.isLoading = false;
        this.toastr.error(err?.message);
      }
    })
  }

}
